export default __webpack_public_path__ + "be9fde9de1ddd0b6c4e1ed2fc36effbd.svg";